import { useEffect, useState } from "react";
import DashboardShell from "@/components/DashboardShell";
import { api, formatErr } from "@/lib/api";
import { Plus } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function SchoolStudents() {
  const [students, setStudents] = useState([]);
  const [profile, setProfile] = useState(null);
  const [form, setForm] = useState({ full_name: "", grade: "Grade 1" });
  const [open, setOpen] = useState(false);

  const reload = async () => {
    const p = await api.get("/schools/profile"); setProfile(p.data);
    const s = await api.get("/schools/students"); setStudents(s.data);
  };
  useEffect(() => { reload(); }, []);

  const add = async (e) => {
    e.preventDefault();
    try {
      await api.post("/schools/students", { ...form, school_id: profile.id });
      toast.success("Student added"); setOpen(false); setForm({ full_name: "", grade: "Grade 1" });
      reload();
    } catch (e) { toast.error(formatErr(e?.response?.data?.detail) || e.message); }
  };

  return (
    <DashboardShell title="Students" subtitle="Keep your pupil roster up to date."
      actions={<button onClick={() => setOpen(true)} className="btn-primary !py-2 !px-4 text-sm" data-testid="add-student-button"><Plus size={14} weight="bold" /> Add student</button>}>
      {open && (
        <form onSubmit={add} className="card mb-6 max-w-2xl" data-testid="add-student-form">
          <h3 className="font-display text-lg font-medium mb-4">New student</h3>
          <div className="grid sm:grid-cols-3 gap-4">
            <Field label="Full name" required><input required className="input mt-1" value={form.full_name} onChange={(e) => setForm({ ...form, full_name: e.target.value })} data-testid="student-name-input" /></Field>
            <Field label="Grade" required><input required className="input mt-1" value={form.grade} onChange={(e) => setForm({ ...form, grade: e.target.value })} data-testid="student-grade-input" /></Field>
          </div>
          <div className="flex gap-3 mt-5">
            <button type="submit" className="btn-primary" data-testid="student-save-button">Save</button>
            <button type="button" onClick={() => setOpen(false)} className="btn-ghost">Cancel</button>
          </div>
        </form>
      )}
      <div className="card">
        {students.length === 0 ? (
          <p className="text-sm text-[#4F5D4F] py-8 text-center">No students yet. Add your first one.</p>
        ) : (
          <table className="dense">
            <thead><tr><th>Name</th><th>Grade</th><th>Student ID</th></tr></thead>
            <tbody>
              {students.map((s) => (
                <tr key={s.id} data-testid={`student-row-${s.id}`}>
                  <td className="font-medium">{s.full_name}</td>
                  <td>{s.grade}</td>
                  <td className="font-mono text-xs">{s.id.slice(0, 8)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </DashboardShell>
  );
}

function Field({ label, required, children }) {
  return <label className="block"><span className="text-xs uppercase tracking-[0.14em] text-[#4F5D4F] font-semibold">{label}{required && <span className="text-[#F2B632]"> *</span>}</span>{children}</label>;
}
